<div class="chat-skeleton" aria-busy="true" aria-live="polite">
  <ng-container *ngFor="let _ of skeletonTurns; let i = index">
    <div class="chat-skeleton__row chat-skeleton__row--user">
      <div class="chat-skeleton__card chat-skeleton__card--user">
        <div class="chat-skeleton__line chat-skeleton__line--w95"></div>
        <div class="chat-skeleton__line chat-skeleton__line--w55"></div>
      </div>
      <div class="chat-skeleton__avatar"></div>
    </div>

    <div class="chat-skeleton__row chat-skeleton__row--agent">
      <div class="chat-skeleton__avatar"></div>
      <div class="chat-skeleton__card">
        <div class="chat-skeleton__line chat-skeleton__line--w95"></div>
        <div class="chat-skeleton__line chat-skeleton__line--w85"></div>
        <div class="chat-skeleton__line chat-skeleton__line--w55"></div>
      </div>
    </div>
  </ng-container>
</div>
